import "./style.css";
import Cookies from "js-cookie";

export default class OrgCookies {
  static selector = ".s-cookies";

  constructor(block) {
    this.block = block;
    this.$button = block.querySelector(".s-button a");
  }

  onClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    Cookies.set("sela--cookie", "1");
    this.block.parentNode.removeChild(this.block);
  }

  onReady() {
    this.$button.addEventListener("click", this.onClick.bind(this));
  }
}
